import type { TaskCardData } from '../types/planner';
import { plannerKeys } from './plannerQuery';

export interface TaskRef {
  kind: 'task' | 'assignment';
  id: string;
}

export function taskRefOf(card: Pick<TaskCardData, 'student_assignment_id' | 'task_id'>): TaskRef {
  return card.student_assignment_id
    ? { kind: 'assignment', id: card.student_assignment_id }
    : { kind: 'task', id: card.task_id ?? '' };
}

export function detailsKeyOf(ref: TaskRef) {
  return ref.kind === 'assignment' ? plannerKeys.assignment(ref.id) : plannerKeys.task(ref.id);
}

export function sameRef(card: Pick<TaskCardData, 'student_assignment_id' | 'task_id'>, ref: TaskRef): boolean {
  return ref.kind === 'assignment' ? card.student_assignment_id === ref.id : card.task_id === ref.id;
}
